import { loader } from "graphql.macro";
import client from "graphql/client";
import { LOAD_AUDIT_TEMPLATE } from "redux/types";
import { snackbarError } from "shared/redux/actions/Snackbar";

const loadAuditTemplateQuery = loader("graphql/queries/auditTemplates/fetchAuditTemplate.graphql");

export const loadAuditTemplate = (bookId) => {
    return async (dispatch) => {
        try {

            const { data } = await client.query({
                query: loadAuditTemplateQuery,
                variables: { bookId },
                fetchPolicy: "network-only",
            });

            dispatch({
                type: LOAD_AUDIT_TEMPLATE,
                payload: data.auditTemplate,
            });

        } catch (error) {
            console.error("Failed to load audit template:", error);
            dispatch(snackbarError("Failed to load audit template"));
        }
    };
};